query MegaMenu($siteId: [QueryArgument]) {
  entries(siteId: $siteId, section: "megaMenu", level: 1) {
    ...on menuEntry_Entry {
      title
      menuLink {
        url
        label
      }
    }
    children {
      id
      title
      ...on menuEntry_Entry {
        menuLink {
          url
          label
        }
      }
    }
  }
}